// v1.1.0 · Cómo trabajamos + alcance por países y sectores
// v1.3.0 · El proceso de 60 días vive en el hero (regla interactiva); aquí queda el alcance
// v1.4.0 · Bandera junto a cada país
import React from 'react';
import { reach } from '../../data/site';
import Flag from './Flag';

export default function SiteMethod() {
  const total = reach.countries.reduce((s, c) => s + c.projects, 0);
  const max = Math.max(...reach.countries.map((c) => c.projects));
  return (
    <section id="alcance" data-scan className="seam scroll-mt-24 border-t border-[var(--line)] bg-[var(--sheet)] py-20 lg:py-24">
      <div className="mx-auto grid max-w-[1240px] gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <div data-reveal>
          <h2 className="display-2 text-[2.2rem] sm:text-[2.6rem]">
            <span className="num">{total}</span> proyectos en {reach.countries.length} países
          </h2>
          <ul className="mt-8 space-y-3.5">
            {reach.countries.map((c) => (
              <li key={c.name} className="grid grid-cols-[150px_1fr_28px] items-center gap-4 text-[15px]">
                <span className="flex items-center gap-2.5"><Flag code={c.flag} title={`Bandera de ${c.name}`} /> {c.name}</span>
                <span className="h-2 rounded-full bg-[#E3E9E8]">
                  <span className="block h-full rounded-full bg-[var(--ink)]" style={{ width: `${(c.projects / max) * 100}%` }} />
                </span>
                <span className="num text-right font-semibold">{c.projects}</span>
              </li>
            ))}
          </ul>
        </div>
        <div data-reveal style={{ '--rd': '140ms' }}>
          <h2 className="display-2 text-[2.2rem] sm:text-[2.6rem]">Sectores que atendemos</h2>
          <p className="mt-8 text-[1.3rem] leading-[1.7] text-[var(--ink-2)]">
            {reach.sectors.map((s, i) => (
              <React.Fragment key={s}>
                <span className="text-[var(--ink)]">{s}</span>
                {i < reach.sectors.length - 1 ? ', ' : '.'}
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
    </section>
  );
}
